



































































































































































































































































































































import { Component, Prop, Emit } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import BasicHelperMixin from '@/components/helpers/basic-helper-mixin';
import CurrencyMixin from '@/components/helpers/currency-mixin';

import CostModel from '@/views/reports/forms/campaign/components/cost-model.vue';

import WorkspaceSelect from '@/views/reports/pickers/wokrspace-select.vue';
import NoTagFound from '@/views/reports/views/no-tag-found.vue';
import CampaignTutorialMixin from '@/views/reports/forms/campaign/config/campaign-tutorial-mixin';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import TrafficSourceAPI from '@/services/rest/bemob/traffic-source';

@Component({
  components: {
    WorkspaceSelect,
    NoTagFound,
    CostModel,
  }
})
export default class CreateCampaignDialogPanelOne extends mixins(BasicHelperMixin, CurrencyMixin, CampaignTutorialMixin, PlanLimitsMixin) {
  trafficSourceSelectOptions:TrafficSource[] = []

  @Prop({ default: () => {} })
  form: any;

  @Prop({ default: () => {} })
  defaultForm: any;
  trafficSourceApi: TrafficSourceAPI = new TrafficSourceAPI();

  @Prop()
  edit: any;

  @Prop()
  closeModal: any;

  @Prop()
  allWorkspaceIds: string[];

  @Prop()
  campaignInitialState: Campaign;

  @Prop()
  defaultWorkspace: { id:string};

  @Prop()
  workspacesList: any; 

  @Prop({ default: () => {} })
  errorsDict: any;

  @Prop({ default: () => [] })
  offerOptions: Offer[];

  @Emit('change-tracking-domain')
  onChangeTrackingDomain(event: any) {}

  mounted() {
    const {uploadedForWorkspace, isAllInCache, data, isUploaded} = this.$store.state.cache.trafficSources;
    if(isUploaded && isAllInCache) {
      return this.trafficSourceSelectOptions = data.filter(item => this.$store.getters.allPublicWorkspacesIds.includes(item.workspaceId) || item.workspaceId === this.form.workspaceId)
    }

    if(isUploaded && !isAllInCache && uploadedForWorkspace === this.form.workspaceId){
      return this.trafficSourceSelectOptions = data
    }


    if(this.form.workspaceId === this.defaultWorkspace.id){
      return this.trafficSourceApi.updateStoreCache({workspaceId:this.defaultWorkspace.id}).then((res:TrafficSource[])=>{
        this.trafficSourceSelectOptions = res
      })
    }

    return this.trafficSourceApi.getList({
      status:'active',
      limit:'200',
      orderBy:'updated',
      orderDirection:'desc',
      columns:['name','id','workspaceId'],
      workspaceId:this.form.workspaceId
    }).then((res:TrafficSource[])=>{
      this.trafficSourceSelectOptions = res
    })
  }

  @Emit('change-workspace')
  onChangeWorkspace(value: any) {
    this.form.trafficSource = {
      name: this.t('None'),
      id: ''
    };
    this.onChangeWorkspaceUpdateTrafficSource(value)
  }

  @Emit('change-country')
  onChangeCountry(event: any) {}

  onChangeWorkspaceUpdateTrafficSource(workspaceId: any) {
    const {uploadedForWorkspace, isAllInCache, data, isUploaded} = this.$store.state.cache.trafficSources;
    if(isUploaded && isAllInCache) {
      return this.trafficSourceSelectOptions = data.filter(item => this.$store.getters.allPublicWorkspacesIds.includes(item.workspaceId) || item.workspaceId === this.form.workspaceId)
    }

    if(isUploaded && !isAllInCache && uploadedForWorkspace === workspaceId){
      return this.trafficSourceSelectOptions = [...data]
    }
    
    return this.trafficSourceApi.getList({
      status:'active',
      orderBy:'updated',
      orderDirection:'desc',
      limit:'200',
      columns:['name','id','workspaceId'],
      workspaceId:workspaceId
    }).then((res:TrafficSource[])=>{
      this.trafficSourceSelectOptions = res
    })
  }
 

  get trafficLossPercent() {
    return this.form.trafficLossPercent
  }

  get FFconversionNotificationUrlEnabled() {
    return this.$FF.conversionNotificationUrl?.enabled
  }

  get useClientHintsItems() {
    return [
      {
        value: 0,
        text: this.t('Default (as in Global Settings)')
      },
      {
        value: 1,
        text: this.t('Enabled (For This Campaign)'),
      },
      {
        value: 2,
        text:this.t('Disabled (For This Campaign)')
      }
    ]
  }

  get botFiltersModeItems() {
    return [
      {
        value: 0,
        text: this.t('Default (as in Global Settings)')
      },
      {
        value: 1,
        text: this.t('Enabled (For This Campaign)'),
        click: !this.$PL.botFiltersAccess && (()=>{
          this.bus.emit('open-dialog', {
            name: 'ConfirmDialog',
            data: {
              onConfirm: () => {
                this.closeModal();
                this.$router.push({
                  name: 'app.profile.bot-filters'
                });
              },
              title:'',
              message: this.t('To enable bot filters for the campaign, you first need to activate this feature at the account level.<br>Click <b>“Go to Settings”</b> to proceed with purchase and activation of the filters.'),
              confirmButtonText: this.t('Go to Settings'),
            }})
        })
      },
      {
        value: 2,
        text:this.t('Disabled (For This Campaign)')
      }
    ]
  }

  get trafficSourceSelectOptionsWithNone() {
    return  [{
      name: this.t('None'),
      id: ''
    },...this.trafficSourceSelectOptions]
  }

  set trafficLossPercent(val) {
    this.form.trafficLossPercent = Number((+val || 0).toFixed(6).toString())
  }
  
  get customConversions() {
    const customEvents = Object.values(this.$store.state.table.customEvents) as customEvent[]
    return customEvents.filter((item:customEvent)=>item.sendPostback 
      && item.status==='active' 
      || this.form.sendCustomConversionIds.includes(item.id)
    ).map((item:customEvent)=> ({ 
        ...item,
        name: item.status === 'archived' ? `${item.name} (${this.t('Archived')})` : item.name
      })
    )
  }

  get useTrafficLoss() {
    return this.form.useTrafficLoss
  }

  set useTrafficLoss(val) {
    this.form.trafficLossPercent = val ? 0 : null
    this.form.useTrafficLoss = val
  }

  get postbackPercent() {
    return this.form.postbackPercent
  }

  set postbackPercent(val) {
    this.form.postbackPercent = Number((+val || 0).toFixed(6).toString())
  }

  get usePostback() {
    return this.form.usePostback
  }

  set usePostback(val) {
    this.form.postbackPercent = val ? 100 : null
    this.form.usePostback = val
  }

  get currencyList() {
    return this.$store.state.currencyList;
  }

  get nameDescriptionCountryName() {
    return this.countryName || this.t('Global');
  }

  get nameDescriptionName() {
    return this.form.name || this.t('None');
  }

  get nameDescription() {
    return `${this.form.trafficSource?.name || this.t('None')} - ${this.nameDescriptionCountryName} - ${this.nameDescriptionName}`;
  }
  
  get countryListPlusGlobal() {
    return this.$store.getters.countryListPlusGlobal;
  }

  get countryName() {
    let result = '';

    if (this.form.countryId) {
      let country = this.countryListPlusGlobal.find((e: any) => e.id === this.form.countryId);
      if (country) {
        result = country.name;
      }
    }

    return result;
  } 
  
  get trackingDomains() {
    return this.$store.getters.cache.trackingDomainsWithAccountDefault.filter((item)=>{
      if(!item.id) return true;
      return this.allWorkspaceIds.some(workspace=>item.workspaceIds.includes(workspace))
    })
  }

  get uniquenessPeriod() {
    return this.form.uniquenessPeriod/3600;
  }

  set uniquenessPeriod(value: number) {
    this.form.uniquenessPeriod = value * 3600;
  }

  get showPlanLimitsWarning_uniqness() {
    return this.form.uniquenessPeriod  !== this.defaultForm.uniquenessPeriod && this.hasPlanLimitsRestriction('uniquenessPeriod')
  }

  get showPlanLimitsWarning_usePostback() {
    return this.usePostback && this.hasPlanLimitsRestriction('sendPostbacksCampaign')
  }

  get showPlanLimitsWarning_useTrafficLoss() {
    return this.useTrafficLoss && this.hasPlanLimitsRestriction('trafficLossCampaign')
  }

  get showPlanLimitsWarning_tags() {
    return this.form.tags?.length && this.hasPlanLimitsRestriction('tagsCampaigns')
  }
  
  clearTags(){
    this.form.tags = []
  }
  
  get hasAtLeastOneConversion(){
    const customEvents = Object.values(this.$store.state.table.customEvents) as customEvent[]
    return !!customEvents.filter(item=>item.status === 'active').length
  }
  
  onSendCustomConversionsClick(value){
    if((value==='include'|| value==='exclude') && !this.hasAtLeastOneConversion){
      this.bus.emit('open-dialog', {
        name: 'CustomConversionsSending', 
      })
      return true;
    }
  }

  resetPostback(){
    this.form.usePostback = false
    this.form.postbackPercent = null
  }

  resetTrafficLoss(){
    this.form.useTrafficLoss = false
    this.form.trafficLossPercent = null
  }

  get fetchTrafficSourcesOptions(){
    if(this.$store.state.cache.trafficSources.isAllInCache){
      return
    }
    return ({ search })=>this.trafficSourceApi.getList({
      search:search,
      status:'active',
      orderBy:'updated',
      orderDirection:'desc',
      limit:'200',
      columns:['name','id','workspaceId'],
      workspaceId:this.form.workspaceId
    })
  }

  resetUniquenessPeriod(){
    this.form.uniquenessPeriod = 86400
  }
}
